$(function() {
    var articles = $('.articles-page .articles-container .article-card').size();
    var loadItems = 3;

    $('.articles-page .btn-load').click(function(e) {
        e.preventDefault();
        loadItems = (loadItems + loadItems <= articles) ? loadItems + loadItems : articles;
        $('.articles-page .articles-container .article-card:lt(' + loadItems + ')').removeClass('hidden-article');

        var lazyImg = $('.articles-page .articles-container .article-card:lt(' + loadItems + ')');
        $(lazyImg).each(function(lazy) {
            if(window.innerWidth > 768){
                var dataImg = $($(lazyImg)[lazy]).find('.article-card-img img').attr('data-imgSrc');
            }else{
                var dataImg = $($(lazyImg)[lazy]).find('.article-card-img img.hide-desktop').attr('data-imgSrc');
            }
            $($(lazyImg)[lazy]).find('.article-card-img img').attr('src', dataImg)
        });

        if (loadItems === articles) {
            $(this).hide();
        }
    })

    $('.sliders .slider-component:not(.nav-slider), .twoBlocks .slider-component:not(.nav-slider)').slick('slickSetOption', {
        arrows: false,
        dots: false,
        asNavFor: '.slider-component.nav-slider'
    });
    $('.sliders .slider-component:not(.nav-slider), .twoBlocks .slider-component:not(.nav-slider)').slick( 'refresh' );

    $('.sliders .slider-component.nav-slider, .twoBlocks .slider-component.nav-slider').slick('slickSetOption', {
        slidesToScroll: 1,
        asNavFor: '.sliders .slider-component:not(.nav-slider), .twoBlocks .slider-component:not(.nav-slider)',
        dots: false,
        focusOnSelect: true
    });
    $('.sliders .slider-component.nav-slider, .twoBlocks .slider-component.nav-slider').slick( 'refresh' );

    var $status = $('.pagination');
    var $slickElement = $('.sliders .slider-component:not(.nav-slider), .twoBlocks .slider-component:not(.nav-slider)');

    $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + '/' + slick.slideCount);
    });

    if(window.innerWidth > 768){
        $('.featured-articles-tips .slider-component').slick('unslick')
    }

     // TAGGING PLAN
    $(".twoBlocks-two .slick-arrow").click(function(){
		$(this).attr("data-kl-event", "eventClick")
		$(this).attr("data-kl-category", "Bathrooms change lives")
        $(this).attr("data-kl-action", "click-slider")
        if($(this).hasClass('slick-prev')){
            $(this).attr("data-kl-label", "left")
        }else{
            $(this).attr("data-kl-label", "right")
        }
	});

})